import type { Route } from 'next';
import type { ReactNode } from 'react';

import { LinkWithChevron } from '#components/Link/LinkWithChevron';

type Props = {
	children: ReactNode;
	href: Route;
	target?: '_blank';
};

export function BoardSectionItemLink({ children, href, target }: Props) {
	return (
		<li>
			<LinkWithChevron className="body3" href={href} target={target}>
				{children}
			</LinkWithChevron>
		</li>
	);
}
